module.exports = __webpack_public_path__ + "img/tutu.1c7fce6b.png";